import classNames from 'classnames';
import PropTypes from 'prop-types';
import { prop, uniqBy } from 'ramda';
import styles from './styles';

const PcModelOptionsSubGroupTabs = ({
  subGroups,
  selectedSubGroup,
  onTabClick,
}) => {

  if (subGroups.length < 2) return null;
  const tabs = uniqBy(prop('option_sub_group_id'), subGroups);

  return (
    <>
      <div className="tabs">
        <button
          type="button"
          className={classNames('tab', {
            'selected-tab': selectedSubGroup === null,
          })}
          onClick={() => onTabClick(null)}
        >
          ALL
        </button>

        {tabs.map((subGroup, k) => (
          <button
            data-groupName={subGroup.sub_group_name}
            key={`${subGroup.sub_group_name}-${k}`}
            type="button"
            className={classNames('tab', {
              'selected-tab':
                selectedSubGroup?.option_sub_group_id === subGroup.option_sub_group_id,
            })}
            onClick={() => onTabClick(subGroup)}
          >
            {subGroup.sub_group_name}
          </button>
        ))}
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

PcModelOptionsSubGroupTabs.propTypes = {
  subGroups: PropTypes.arrayOf(PropTypes.object),
  selectedSubGroup: PropTypes.string,
  onTabClick: PropTypes.func.isRequired,
};

PcModelOptionsSubGroupTabs.defaultProps = {
  subGroups: [],
  selectedSubGroup: null,
};

export default PcModelOptionsSubGroupTabs;
